<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 15 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <polygon [attr.fill]="color" points="5 12 0 7 2 5 5 8 13 0 15 2"></polygon>
</svg>
